import { Record } from "immutable";
import {
  DeliveraDishInterface,
  DeliveraEnergyInfos,
  DeliveraModifierGroupeRuleInterface,
  DeliveraPriceInfoInterface,
  SuspensionRule,
  TaxeInfoInterface,
  TranslationInterface,
} from "./interface";

export interface DeliveraItemInterface {
  id: string;
  external_data?: string;
  title: TranslationInterface;
  description: TranslationInterface;
  image_url?: string;
  price_info: DeliveraPriceInfoInterface;
  modifier_group_ids?: DeliveraModifierGroupeRuleInterface;
  tax_info: TaxeInfoInterface;
  nutritional_info: DeliveraEnergyInfos;
  dish_info: {
    classifications: DeliveraDishInterface;
  };
  suspension_info?: SuspensionRule;
  // visibility_info: DeliveraVisibilityInfosInterface
}

const deliveraItemDefaultProps: DeliveraItemInterface = {
  id: "",
  external_data: "",
  title: {
    translations: {
      fr: "",
      en: "",
    },
  },
  description: {
    translations: {
      fr: "",
      en: "",
    },
  },
  image_url: "",
  price_info: {
    context_type: "ITEM",
    context_value: "0.00€",
    price: 0,
  },
  modifier_group_ids: {
    ids: [],
    overrides: [],
  },
  tax_info: {
    vat_rate_percentage: 10,
  },
  nutritional_info: {},
  dish_info: {
    classifications: {},
  },
  suspension_info: {
    suspension: {
      suspend_until: parseInt((new Date().getTime() / 1000).toFixed(0)),
      reason: "",
    },
  },
  // visibility_info: {
  //     hours: [{
  //         hours_of_week: [
  //             {
  //                 'day_of_week': 'monday',
  //                 'time_periods': [
  //                     {
  //                         'start_time': '00:01',
  //                         'end_time': '23:59'
  //                     }
  //                 ]
  //             },
  //             {
  //                 'day_of_week': 'tuesday',
  //                 'time_periods': [
  //                     {
  //                         'start_time': '00:01',
  //                         'end_time': '23:59'
  //                     }
  //                 ]
  //             },
  //             {
  //                 'day_of_week': 'wednesday',
  //                 'time_periods': [
  //                     {
  //                         'start_time': '00:01',
  //                         'end_time': '23:59'
  //                     }
  //                 ]
  //             },
  //             {
  //                 'day_of_week': 'thursday',
  //                 'time_periods': [
  //                     {
  //                         'start_time': '00:01',
  //                         'end_time': '23:59'
  //                     }
  //                 ]
  //             },
  //             {
  //                 'day_of_week': 'friday',
  //                 'time_periods': [
  //                     {
  //                         'start_time': '00:01',
  //                         'end_time': '23:59'
  //                     }
  //                 ]
  //             },
  //             {
  //                 'day_of_week': 'saturday',
  //                 'time_periods': [
  //                     {
  //                         'start_time': '00:01',
  //                         'end_time': '23:59'
  //                     }
  //                 ]
  //             },
  //             {
  //                 'day_of_week': 'sunday',
  //                 'time_periods': [
  //                     {
  //                         'start_time': '00:01',
  //                         'end_time': '23:59'
  //                     }
  //                 ]
  //             },
  //         ]
  //     }]
  // }
};

export default class DeliveraItem extends Record(deliveraItemDefaultProps) {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(props: any) {
    super(props);
    // console.log("suspension info => ", props.suspension_info);
  }
}
